import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=450e5ad3&scoped=true&lang=pug&"
import script from "./Plan.vue?vue&type=script&lang=js&"
export * from "./Plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e5ad3",
  null
  
)

export default component.exports